import './App.css';
import Navbar from './components/NavBar';
import Home from './pages/Home';
import About from './pages/About';
import Projects from './pages/Projects';
import Skills from './pages/Skills';
import Contact from './pages/Contact';

import { motion, AnimatePresence } from "framer-motion";
import { ChevronDoubleUpIcon } from "@heroicons/react/24/solid";
import { useEffect, useState } from 'react';
import Footer from './pages/Footer';
import CareerTimeline from './pages/CareerTimeline';
import Personality from './pages/Personality';
import ScrollProgress from "./components/ScrollProgress";

function App() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 200);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleClick = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <>
      <ScrollProgress />
      <Navbar />
      <Home />
      <About />
      <Projects />
      <CareerTimeline />
      <Skills />
      <Personality />
      <Contact />
      <Footer/>

      <AnimatePresence>
        {visible && (
          <motion.button
            key="backtotop"
            initial={{ opacity: 0, scale: 0.8, y: 20 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.8, y: 20 }}
            transition={{ duration: 0.2 }}
            onClick={handleClick}
            aria-label="Back to top"
            className="fixed bottom-6 right-6 z-50 bg-indigo-500 dark:bg-indigo-600 text-white p-3 rounded-full shadow-lg hover:shadow-xl hover:scale-110 focus:outline-none focus:ring-2 focus:ring-indigo-400 transition-all"
          >
            <ChevronDoubleUpIcon className="h-5 w-5" />
          </motion.button>
        )}
      </AnimatePresence>
    </>
  );
}

export default App;
